import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import api from "@/lib/api";

import Layout from "@/components/Layout";
import Analytics from "@/components/Analytics";
import Home from "@/pages/Home";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Campaigns from "@/pages/Campaigns";
import LegalPage from "@/pages/LegalPage";
import Admin from "@/pages/Admin";

const LEGAL_PAGES = [
  { path: "/kiralama-kosullari", key: "terms" },
  { path: "/gizlilik-politikasi", key: "privacy" },
  { path: "/kvkk", key: "kvkk" },
  { path: "/cerez-politikasi", key: "cookie" },
];

function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data);
      } catch {}
      window.history.replaceState(null, "", "/admin");
      navigate("/admin", { replace: true });
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
      <div className="text-center">
        <div className="h-10 w-10 border-4 border-[#A11016] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-neutral-600">Giriş yapılıyor...</p>
      </div>
    </div>
  );
}

function PixelPageView() {
  const location = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (typeof window.fbq === "function") window.fbq("track", "PageView");
  }, [location.pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/araclar" element={<Vehicles />} />
        <Route path="/araclar/:slug" element={<VehicleDetail />} />
        <Route path="/nasil-calisir" element={<HowItWorks />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/sss" element={<Faq />} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/kampanyalar" element={<Campaigns />} />
        {LEGAL_PAGES.map((l) => (
          <Route key={l.key} path={l.path} element={<LegalPage pageKey={l.key} />} />
        ))}
      </Route>
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Analytics />
            <PixelPageView />
            <AppRouter />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
